import * as angular from 'angular';
import {IController} from "angular";
import {SplitService} from "../../../commons/services/split-service.service";
import {FulfillmentStepModel} from "../../models/fulfillment-step.model";

export class FulfillmentStepsTotalsIndicationComponent implements IController {
  fulfillmentSteps: FulfillmentStepModel[];

  public totalPackages: number;
  public totalWeight: number;
  public totalVolume: number;
  public weightConfig: string;
  public dimensionsConfig: string;

  constructor(private splitService: SplitService) {
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();
  }

  $onInit() {
    if (this.fulfillmentSteps?.length) {
      this._initTotalsData();
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.fulfillmentSteps) {
      if (this.fulfillmentSteps?.length) {
        this._initTotalsData();
      } else {
        this.totalPackages = undefined;
        this.totalWeight = undefined;
        this.totalVolume = undefined;
      }
    }
  }

  private _initTotalsData() {

    this.totalPackages = 0;
    this.totalWeight = 0;
    this.totalVolume = 0;

    this.fulfillmentSteps.forEach((fulfillmentStep: FulfillmentStepModel) => {

      this.totalPackages += fulfillmentStep.itemsExt?.reduce((sum, i) => {
        return sum + (i.count || 0);
      }, 0);

      this.totalWeight += fulfillmentStep.itemsExt?.reduce((sum, i) => {
        return sum + (i.weight || 0);
      }, 0);

      this.totalVolume += fulfillmentStep.itemsExt?.reduce((sum, i) => {
        return sum + (i.volume || i.dimensions?.cube || 0);
      }, 0);


    })

  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentStepsTotalsIndication', {
    bindings: {
      fulfillmentSteps: '<',
    },
    template: require('./fulfillment-steps-totals-indication.html').default,
    controller: FulfillmentStepsTotalsIndicationComponent
  });
